var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65056 0.563563C2.155 1.63364 0.406982 4.11262 0.406982 7C0.406982 10.8661 3.54088 14 7.40698 14C11.2731 14 14.407 10.8661 14.407 7C14.4078 5.99718 14.1928 5.00593 13.7764 4.09363C13.3601 3.18133 12.7522 2.36935 11.9941 1.7129L13.707 0H9.50698V4.2L11.0015 2.7055C12.0114 3.55066 12.6911 4.72468 12.9212 6.02128C13.1514 7.31788 12.9172 8.65411 12.2599 9.7952C11.6026 10.9363 10.5642 11.8092 9.32714 12.2607C8.09007 12.7121 6.73348 12.7131 5.49572 12.2636C4.25796 11.814 3.21822 10.9427 2.55918 9.80259C1.90013 8.6625 1.66395 7.32663 1.89213 6.02968C2.1203 4.73273 2.79824 3.55768 3.80682 2.71098C4.2326 2.35354 4.7058 2.06428 5.20959 1.84932L4.65056 0.563563Z",
    fill: "#ACB2C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.53a26344c83740bc6f3dbf7dfbace075.svg";
export { ForwardRef as ReactComponent };